import { renderInDocument } from '@spotahome/soyuz/client';

import ContactUsContainer from './main';

renderInDocument(ContactUsContainer);
